import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { dlGtpDataVolumeNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the DlGtpDataVolumeNrCell component
 */
interface DlGtpDataVolumeNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Downlink GTP Data Volume Chart (NR Cell Level)
 * 
 * Displays downlink S1-U GTP data volume in GB for individual NR cells.
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (dlGtpDataVolumeNrCellChartConfig)
 * @see API: /api/nr/cell/dl-gtp-data-volume?cell_name={cellName}
 */

const DlGtpDataVolumeNrCell: React.FC<DlGtpDataVolumeNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={dlGtpDataVolumeNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default DlGtpDataVolumeNrCell;
